import React from "react";
import { View } from "react-native";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import Skeletons from "./Skeletons";

const GameShowEventDetailSkeleton = () => {
  const deviceSize = useDeviceSize();
  let skeletonCards = Array(3).fill(0);

  return (
    <View style={{ marginTop: 35 }}>
      {deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM ? (
        <Skeletons
          height={192}
          style={{
            borderRadius: 10,
          }}
        />
      ) : (
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <View style={{ flexDirection: "row", gap: 10 }}>
            {skeletonCards.map((_, index) => (
              <Skeletons
                key={index}
                height={50}
                width="150px"
                style={{
                  borderRadius: 10,
                }}
              />
            ))}
          </View>
          <View>
            <Skeletons
              height={40}
              width="200px"
              style={{
                borderRadius: 10,
              }}
            />
          </View>
        </View>
      )}
    </View>
  );
};

export default GameShowEventDetailSkeleton;
